<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="primary" v-bind="attrs" v-on="on" @click="equal">
        {{ $t('cap_assign_branch') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h6 primary--text">
          {{ $t('cap_assign_branch') }}
        </span>
      </v-card-title>
      <v-card-subtitle class="pt-2 pt-md-4">
        <span> {{ $t('cap_assign_branch_info') }}</span>
      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="branch"
                :items="$store.state.tenant.branches"
                item-text="name"
                item-value="name"
                filled
                chips
                :hint="$t('btn_cap_branches')"
                outlined
                persistent-hint
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="branch = ''"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content
                      v-text="data.item"
                    ></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.name"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.active"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          {{ $t('btn_cap_close') }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="assignBranch">
          {{ $t('btn_cap_save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CassAssignBranch',
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    }
  },
  data() {
    return {
      dialog: false,
      branch: null,
      rules: {
        required: [
          (v) =>
            Array.isArray(v)
              ? !!v && v.length > 0
              : !!v || this.$t('cap_msg_required')
        ]
      }
    }
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    }
  },
  methods: {
    assignBranch() {
      this.dialog = false
      const assignBranch = {
        documentId: this.documentId,
        branch: this.branch
      }
      this.$store
        .dispatch('order/assignBranch', assignBranch)
        .then(() => {
          // eslint-disable-next-line
          console.log('success')
        })
        .catch(() => {
          // eslint-disable-next-line
          console.log('Error')
        })
    },
    equal() {
      this.branch = this.orderDetail.branch
    }
  }
}
</script>

<style scoped></style>
